import {
    GET_FEE_TYPES_FAIL,
    GET_FEE_TYPES_SUCCESS,
    ADD_FEE_TYPE_SUCCESS,
    ADD_FEE_TYPE_FAIL,
    UPDATE_FEE_TYPE_SUCCESS,
    UPDATE_FEE_TYPE_FAIL,
    DELETE_FEE_TYPE_SUCCESS,
    DELETE_FEE_TYPE_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    feeTypes: [],
    error: null,
    loading: true,
    success: false
};

const feeTypeReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des feeTypes
        case GET_FEE_TYPES_SUCCESS:
            return {
                ...state,
                feeTypes: action.payload, // tableau d'objets feeType
                loading: false,
                error: null
            };

        case GET_FEE_TYPES_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une feeTypee
        case ADD_FEE_TYPE_SUCCESS:
            return {
                ...state,
                feeTypes: [action.payload, ...state.feeTypes], // ajoute au début du tableau
                error: null,
                success: true
            };

        case ADD_FEE_TYPE_FAIL:
            return {
                ...state,
                error: action.payload,
                 success: false
            };

        // Mise à jour d'une feeTypee
        case UPDATE_FEE_TYPE_SUCCESS:
            return {
                ...state,
                feeTypes: state.feeTypes.map(feeType =>
                    feeType.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet feeType
                        : feeType
                ),
                error: null,
                 success: true
            };

        case UPDATE_FEE_TYPE_FAIL:
            return {
                ...state,
                error: action.payload,
                 success: false
            };

        // Suppression d'une feeTypee
        case DELETE_FEE_TYPE_SUCCESS:
            return {
                ...state,
                feeTypes: state.feeTypes.filter(
                    feeType => feeType.id !== action.payload
                ),
                error: null
            };


        case DELETE_FEE_TYPE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        case "RESET_LAST_ACTION_SUCCESS":
            return { 
                ...state, 
                success: false 
            };


        default:
            return state;
    }
};

export default feeTypeReducer;
